#import "./cartFragment.gql"

query cart($id: ID!, $lang: LanguageCode!) @inContext(language: $lang) {
  cart(id: $id) {
    ...cartFragment
  }
}
